import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrl: '../admission-ui.component.scss'
})
export class LoadingScreenComponent {

}
